export default __webpack_public_path__ + "9ea8ab2bbf49455f89c5aa8d88013571.svg";